<script setup>
import {ref} from 'vue'
import {useRouter} from 'vue-router';
import {Button} from "@/components/ui/button";
import {Loader} from 'lucide-vue-next';
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";
import {Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle} from '@/components/ui/card'
import {ChevronRight} from "lucide-vue-next";
import {CreateOrganisation} from "@/services/organisationService.js";

const router = useRouter();

const isLoading = ref(false)
const name = ref('')

async function onSubmit(event) {
  event.preventDefault();
  isLoading.value = true;

  try {
    let organisation = await CreateOrganisation(name.value);
    await router.push({path: `/${organisation.id}`});
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
}
</script>

<template>
  <div class="container mx-auto pt-16">
    <Card class="w-1/2 mx-auto">
      <CardHeader>
        <CardTitle class="text-2xl">
          Create company
        </CardTitle>
        <CardDescription>
          Let's get rolling! Creating a company is quick and easy.
        </CardDescription>
      </CardHeader>
      <CardContent class="grid gap-4">
        <div class="grid gap-2">
          <Label for="name">Campsite name</Label>
          <Input
              id="name"
              type="text"
              placeholder="My awesome company"
              required
              :disabled="isLoading"
              v-model="name"
          />
        </div>
      </CardContent>
      <CardFooter>
        <Button class="w-1/3 mr-8" @click="router.back()" variant="ghost" :disabled="isLoading">
          Cancel
        </Button>

        <Button class="w-2/3" @click="onSubmit" :disabled="isLoading">
          <Loader v-if="isLoading" class="mr-2 h-4 w-4 animate-spin"/>
          Next
          <ChevronRight/>
        </Button>
      </CardFooter>
    </Card>
  </div>

</template>

<style scoped>

</style>